import { service } from './request'

import xy_config from '../config/xy_config'
import VueCookie from 'vue-cookie'
import { getApiToken } from '../utils/eShopHttpUtils'

export default async (url, data) => {
  try {
    const mParam = { ...(data ? data : {}) }
    const tokenCookie = VueCookie.get(xy_config.cookieToken)
    if (tokenCookie) {
      const tokenJSON = JSON.parse(tokenCookie)
      mParam['userid'] = tokenJSON.user_id
      mParam['user_token'] = tokenJSON.user_token
    }
    return await service.post(url, mParam)
  } catch (error) {
    throw error
  }
}

const loadEShopAPi = async (url, data) => {
  try {
    const mParam = { ...(data ? data : {}) }
    const ts = new Date().getTime()
    mParam['ts'] = ts
    mParam['client_id'] = xy_config.client_id
    mParam['api_token'] = getApiToken(xy_config.client_id, url, ts)
    return await service.post(url, mParam)
  } catch (error) {
    throw error
  }
}

const loadEShopAPiWithToken = async (url, data) => {
  try {
    const tokenCookie = VueCookie.get(xy_config.cookieToken)
    if (!tokenCookie) {
      return
    }
    const tokenJSON = JSON.parse(tokenCookie)
    const mParam = { ...(data ? data : {}) }
    mParam['user_id'] = tokenJSON.user_id
    mParam['user_token'] = tokenJSON.user_token
    return await loadEShopAPi(url, mParam)
  } catch (error) {
    throw error
  }
}

export { loadEShopAPi, loadEShopAPiWithToken }
